import * as React from 'react';

function SvgKnifeWiper(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 293.3 293.3"
      {...props}
    >
      <path d="M36.2 237.7l-16.7 16.7c-6 6-7.6 14.5-4.2 22.6 3.9 9.4 13.6 16.3 23.1 16.3 5.3 0 10.2-2.1 14.1-5.9 8.9-8.9 7.7-17 6.9-22.3-.6-4.1-.8-5.5 2.4-8.8 3.7-3.7 7.2-5.3 12.5-7.7 9-4 21.3-9.5 40.5-28.8l20.6-21-24.5-24.5c-2-2-3.5-4.2-4.6-6.6l-70.1 70zM271.7 2C233.1 39.4 122 152.2 122 152.2c-3 3-3 7.9 0 10.9l35.7 35.7c1.5 1.5 3.5 2.3 5.4 2.3s3.9-.8 5.4-2.3c0 0 44.8-45.1 59.7-60 18.4-18.4 58.2-73.8 50.5-135.4-.3-3.1-3.1-5.1-7-1.4z" />
    </svg>
  );
}

export default SvgKnifeWiper;
